import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController } from '@ionic/angular/lazy';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-order-refund-options',
    templateUrl: './order-refund-options.component.html',
    styleUrls: ['./order-refund-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderRefundOptionsComponent implements OnInit {

    @Input() order_refund_page = null;

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    presentOrderRefundPaymentAddModal() {
        this.order_refund_page.presentOrderRefundPaymentAddModal();
        this.dismiss();
    }

    presentOrderRefundEditModal() {
        this.order_refund_page.presentOrderRefundEditModal();
        this.dismiss();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
